import { Navigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { checkToken } from "../helper"

function GuestOnly({ children }) {
  const dispatch = useDispatch()

  return (
    !checkToken(dispatch) ?
      children :
      <Navigate to="/dashboard" replace />
  )
}

export default GuestOnly